import * as React from "react";
const SvgMinimize20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M2 8h6V2H6v4H2v2Zm0 4h6v6H6v-4H2v-2Zm10-4h6V6h-4V2h-2v6Zm6 4h-6v6h2v-4h4v-2Z",
      clipRule: "evenodd"
    })
  );
export default SvgMinimize20Px;
